import axios from 'axios';

export default class SuggestedPosts
{

    constructor ()
    {
        // these seem to be loaded in the CMS as well.. causing.. strangeness
        if ( window.location.href.includes( '_cms' ) )
        {
            return;
        }

        this.suggestedPostsContainer = document.querySelector( '.suggested-posts-element' );

        if ( !this.suggestedPostsContainer )
        {
            return;
        }


        this.audience      = AsGlobalSettings?.currentPageAudience ?? 'jeunes';
        this.suggestedPosts = this.suggestedPostsContainer.dataset?.suggestedPosts ?? "normal";

        this.getSuggestedPosts();
    }

    async getSuggestedPosts ()
    {
        let queryString = '?' + new URLSearchParams( {
            omitIds       : AsGlobalSettings?.postId ?? false,
            audience      : this.audience,
            suggestedPosts : this.suggestedPosts,
        } ).toString();


        let response = await axios.get( `/endpoints/suggested-posts${queryString}` );

        this.suggestedPostsContainer.innerHTML = response.data;
        this.suggestedPostsContainer.classList.add( 'ready' ); // this is simply to avoir padding when it's empty

        // (maybe) activate mobile slider
        setTimeout( () =>
        {
            const initialCheck = new Event( 'DetectMobileSliders' );
            window.dispatchEvent( initialCheck );
        }, 1000 );
    }

}

